import React from 'react';
import PropTypes from 'prop-types';
import TextArea from 'components/TextArea';

function Comments({ comments, onChange }) {
  return (
    <div>
      <TextArea
        label="Comments / Notes"
        value={comments || ''}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
}

Comments.propTypes = {
  comments: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default Comments;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/Comments.jsx